type TFilterConditionalKeyValues = {
  [key: string]: false | undefined | string | (false | undefined | string)[];
};

type TFilterConditionalKeyValuesReturns = {
  [key: string]: string | string[];
};

/**
 * Filters the input object to include only keys with truthy values.
 *
 * - If a key's value is an array, it filters out falsy values from the array.
 * - If the resulting array is non-empty, the key is included in the output.
 * - If a key's value is not an array but is truthy, the key is included in the output.
 *
 * @param keyValues - An object where each key maps to either an array of values or a single value.
 * @returns A new object containing only the keys with truthy values or non-empty arrays of truthy values.
 */
const filterConditionalKeyValues = (keyValues: TFilterConditionalKeyValues): TFilterConditionalKeyValuesReturns => {
  const truthyKeys = {};
  for (const key in keyValues) {
    if (!keyValues.hasOwnProperty(key)) {
      break;
    }
    const values = keyValues[key];
    if (Array.isArray(values)) {
      const truthyValues = values.filter(Boolean);
      if (truthyValues.length) {
        truthyKeys[key] = truthyValues;
      }
    } else if (values) {
      truthyKeys[key] = values;
    }
  }
  return truthyKeys;
};

export default filterConditionalKeyValues;
